import React from 'react';
import { CalendarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-157">
      <div className="max-w-3xl mx-auto text-center" data-id="element-158">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 mb-6" data-id="element-159">
          <CalendarIcon className="w-8 h-8 text-amber-600" data-id="element-160" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-stone-900 mb-8" data-id="element-161">
          Lo que cambia en solo 7 días
        </h2>
        <p className="text-lg md:text-xl text-stone-700 leading-relaxed bg-amber-50 p-8 rounded-2xl border border-amber-100 shadow-sm" data-id="element-162">
          Notará que la ansiedad de "querer recordar" desaparece. Se sentirá más
          presente en las conversaciones y, al terminar la primera semana, habrá
          creado al menos 50 nuevas conexiones neuronales activas que antes
          estaban dormidas. Su confianza regresará antes que sus recuerdos.
        </p>
      </div>
    </section>;
}